import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/bynder/identity');

const bynderIdentitiesService = createService(httpClient, (client) => ({
    fetchIdentities(query: string) {
        return client.get(`?query=${encodeURIComponent(query)}`);
    },
}));

export default bynderIdentitiesService;
